import React, { useCallback, useMemo } from 'react'
import styles from './styles.module.css'
import ChangelogDate from '../ChangelogDate'
import ChangelogTitle from '../ChangelogTitle'
import ChangelogTag from '../ChangelogTag'
import { navigate } from 'gatsby'

const HomePageChangelogItem = ({ frontmatter, fields }) => {
  const { date, title, app, changeType } = frontmatter
  const { langKey } = fields
  const changelogPath = useMemo(() => `/${langKey}/changelog`, [langKey])
  const onClickNavitateToChangelog = useCallback(() => navigate(changelogPath), [changelogPath])

  const onKeyDownNavigateToChangelog = useCallback(
    event => {
      if (event.key === 'Enter' || event.key === ' ') {
        navigate(changelogPath)
      }
    },
    [changelogPath]
  )

  return (
    <div
      role="button"
      aria-label="Navegar para o changelog"
      onClick={onClickNavitateToChangelog}
      onKeyDown={onKeyDownNavigateToChangelog}
      className={styles.homePageChangelogCard}
      tabIndex={0}
    >
      <ChangelogDate>{date}</ChangelogDate>
      <ChangelogTitle>{title}</ChangelogTitle>
      <div className={styles.homePageChangelogCardTag}>
        {app.map((appItem, appIndex) => (
          <ChangelogTag key={appIndex} filterGroupName="solution">
            {appItem}
          </ChangelogTag>
        ))}
        <ChangelogTag date={date} tooltip={true} filterGroupName="changeType">
          {changeType}
        </ChangelogTag>
      </div>
    </div>
  )
}

export default HomePageChangelogItem
